import * as types from './types';

export const updateProducts = (products) => (dispatch) => (
  dispatch({
    type: types.PRODUCTS_UPDATE_PRODUCTS,
    products
  })
);

export const updateScrollY = (scrollY) => (dispatch) => (
  dispatch({
    type: types.PRODUCTS_UPDATE_SCROLL_Y,
    scrollY
  })
);

export const updateSlug = (slug) => (dispatch) => (
  dispatch({
    type: types.PRODUCTS_UPDATE_SLUG,
    slug
  })
);

export const updatePages = (pages) => (dispatch) => (
  dispatch({
    type: types.PRODUCTS_UPDATE_PAGES,
    pages
  })
);

export const updateSort = (sort) => (dispatch) => (
  dispatch({
    type: types.PRODUCTS_UPDATE_SORT,
    sort
  })
);

export const updateFacets = (facets) => (dispatch) => (
  dispatch({
    type: types.PRODUCTS_UPDATE_FACETS,
    facets
  })
);

export const updateMeta = (meta) => (dispatch) => (
  dispatch({
    type: types.PRODUCTS_UPDATE_META,
    meta
  })
);

export const updateSlider = (slider) => (dispatch) => (
  dispatch({
    type: types.PRODUCTS_UPDATE_SLIDER,
    slider
  })
);

export const updateTracking = (tracking) => (dispatch) => (
  dispatch({
    type: types.PRODUCTS_UPDATE_TRACKING,
    tracking
  })
);

export const updateProduct = (id) => (dispatch) => (
  dispatch({
    type: types.PRODUCTS_UPDATE_CLICKED_PRODUCT,
    id
  })
);
